import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LogService } from '@prekog/common-ui';

import { PartnerStatisticTotals } from '../../shared/models/partner-statistic-totals.model';
import { PartnerStatistics } from '../../statistics/partnerstatistic/partnerstatistics';
import { CalculateStatisticTotalsUseCase } from '../../shared/use-cases/calculate-statistic-totals.usecase';

@Injectable({
    providedIn: 'root'
})
export class CalculatePartnerStatisticTotalsUseCase extends CalculateStatisticTotalsUseCase<PartnerStatistics, PartnerStatisticTotals> {
    constructor(_logService: LogService, _http: HttpClient) {
        super(_logService, _http);
    }

    protected override extractRowTotals(row: PartnerStatistics): PartnerStatisticTotals {
        return {
            delegated: row.delegatedQuantity ?? 0,
            soldFromDelegation: row.soldFromDelegationQuantity ?? 0,
            returned: row.returnedFromDelegationQuantity ?? 0,
            stock: row.stockQuantity ?? 0
        };
    }
}
